<template>
  <v-layout wrap class="pa-0 ma-0" style="margin: 10px 0 !important;">
    <input
        type="file"
        style="display: none"
        ref="file"
        accept="image/*"
        @change="onFilePicked"
    />
    <v-flex xs12 pa-0 ma-0>

      <v-parallax  :src="imageUrl" style="overflow: visible" height="220">

        <v-layout
            align-left
            justify-center
            wrap
            class="pa-0 ma-0"
        >

          <v-btn absolute top right small rounded color="black" style="top: -10px" dark @click.stop="pickFile">{{imgLabel}}</v-btn>

          <v-flex xs12 text-left mt-4 ml-4>
            <slot name="avatar"></slot>
          </v-flex>

        </v-layout>
      </v-parallax>

    </v-flex>
    <div>
      <small class="accent--text" v-if="maxSizeExceeded">Tamaño excedido (max. {{maxSize}}mb.)</small>
    </div>
  </v-layout>

</template>

<script>
    export default {
        props: ['default', 'size', 'imgLabel', 'maxSize'],
        data(){
            return{
                imageName: '',
                imageUrl: this.default || require('@/assets/img/base/bg-blur.jpg'),
                imageFile: ''
            }
        },
        mounted() {
          const vm = this
          if (vm.default) {
            vm.imageUrl = vm.default
          }
        },
        methods:{
            pickFile() {
                this.$refs.file.click()
            },
            onFilePicked(e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.imageName = files[0].name
                    if(this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0]
                        this.$emit('change', files[0])
                    })

                    return
                }

                this.imageName = ''
                this.imageFile = ''
                this.imageUrl = ''

            }
        },
      computed:{
          valid(){
            const vm = this
            if(vm.maxSizeExceeded) return false
            return true
          },
          maxSizeExceeded(){
            const vm = this
            return vm.maxSize && vm.fileSize > Number(vm.maxSize)
          },
          fileSize(){
            const vm = this
            return vm.imageFile && (vm.imageFile.size / 1024 / 1024).toFixed(2) || 0
          }
      },
      watch:{
          valid(val){
            this.$emit('change:validation', val)
          },
        default(val){
          const vm = this
          if (val) {
            vm.imageUrl = val
          }
        }
      }
    }
</script>

<style scoped>
    .v-avatar img{
        object-fit: cover;
    }
</style>
